import * as React from 'react';
import debounce from 'lodash/debounce';
import { FormControl } from '@common/components/form-control';
import cx from 'classnames';

import './Search.styles.scss';

export class Search extends React.Component {
    searchInputRef = React.createRef();

    componentDidUpdate(prevProps) {
        const { value } = this.props;

        if (prevProps.value !== value) {
            this.searchInputRef.current.value = value || '';
        }
    }

    search = () => {
        const { value } = this.searchInputRef.current;
        const { onSearch } = this.props;

        onSearch({ searchKeyword: value });
    }

    handleSubmit = (e) => {
        e.preventDefault();
    }

    render() {
        const { withLiveSearch, liveSearchDelay, className, placeholder = 'Search', style, id } = this.props;

        return (
            <div className={cx('Search', className)} style={style}>
                <i className="fa fa-search Search__icon" onClick={this.search} />
                <form className="Search__form" onSubmit={this.handleSubmit}>
                    <FormControl
                        id={id}
                        placeholder={placeholder}
                        inputRef={this.searchInputRef}
                        className="Search__form__input" type="text"
                        onChange={withLiveSearch
                            ? debounce(this.search, liveSearchDelay || 500)
                            : undefined
                        }
                    />
                </form>
            </div>
        );
    }
}